const {
  Schedule
} = require('../entities');

const scheduleToPrecheckParam = schedule => {
  if (!schedule) return undefined;
  const serialized = Schedule.serialize(schedule);
  return {
    startDate: serialized.startDate,
    endDate: serialized.endDate,
    weekDays: serialized.weekDays,
    minutes: serialized.minutes
  };
};

const schedulesToPrecheckParams = (schedules, type) => {
  if (!schedules) return undefined;
  return schedules.filter(s => !s.type || s.type === type).map(scheduleToPrecheckParam);
};

module.exports = {
  scheduleToPrecheckParam,
  schedulesToPrecheckParams
};